import React from 'react'
import { AppBarHeightPixel } from './appbar/logo'

interface SidebarDrawerProps {
    haveNavbar: boolean
    sidebarContent?: JSX.Element
}
const SidebarDrawer = ({ sidebarContent, haveNavbar }: SidebarDrawerProps) => {
    return (
        <div
            style={{ paddingTop: haveNavbar ? `${AppBarHeightPixel}px` : 0 }}
            className="w-[240px] h-full z-10 h-full hidden sm:flex  border-r">
            {sidebarContent}
        </div>
    )
}

export default SidebarDrawer
